import React from 'react';
import { formatByHint } from './criteriaBarUtils';

export default function CpaWindowsChart({ windowComparison, targetCpa, currency = 'USD' }) {
  if (!windowComparison || typeof windowComparison !== 'object') return null;
  const w = Array.isArray(windowComparison.windows) ? windowComparison.windows : [];
  if (w.length < 2) return null;
  const targetNum = typeof targetCpa === 'number' ? targetCpa : Number(targetCpa);
  const values = w
    .map((x) => (typeof x?.value === 'number' ? x.value : Number(x?.value)))
    .filter((n) => Number.isFinite(n) && n > 0);
  const maxVal = values.length ? Math.max(...values) : 1;
  const maxForScale = Math.max(1, maxVal * 1.1);

  return (
    <div className="mt-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-xs tracking-wide text-white/60 font-semibold">CPA por ventana</div>
          <div className="mt-0.5 text-[11px] text-white/55">
            Objetivo: {Number.isFinite(targetNum) ? formatByHint(targetNum, windowComparison.format_hint, currency) : '—'}
          </div>
        </div>
      </div>

      <div className="mt-3 relative rounded-lg border border-white/10 bg-white/5 px-3 py-3">
        {Number.isFinite(targetNum) ? (
          <div
            className="absolute left-3 right-3 h-[2px] bg-white/60"
            style={{ top: `${(1 - (targetNum / maxForScale)) * 100}%` }}
            aria-hidden="true"
          />
        ) : null}

        <div className="grid grid-cols-2 gap-4 items-end h-[140px]">
          {w.slice(0, 2).map((win, idx) => {
            const cpa = typeof win?.value === 'number' ? win.value : Number(win?.value);
            const hasCpa = Number.isFinite(cpa) && cpa > 0;
            const isCritical = win?.is_critical === true;
            const barH = hasCpa ? Math.max(10, Math.round((cpa / maxForScale) * 130)) : 10;
            const barTone = isCritical ? 'bg-rose-500/45' : 'bg-emerald-500/35';
            const label = String(win?.label || (idx === 0 ? 'Ventana A' : 'Ventana B'));
            const valueLabel = hasCpa ? formatByHint(cpa, windowComparison.format_hint, currency) : '—';
            return (
              <div key={`${label}-${idx}`} className="min-w-0 flex flex-col items-center justify-end gap-2">
                <div className="text-[10px] font-semibold tabular-nums text-white/70 whitespace-nowrap">{valueLabel}</div>
                <div
                  className={`w-full rounded-md ${barTone} border border-white/10`}
                  style={{ height: `${barH}px` }}
                  title={label}
                  aria-label={label}
                />
                <div className="text-[10px] text-white/60 font-semibold text-center leading-snug">
                  <div className="truncate max-w-[120px]" title={label}>{label}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
